export default __webpack_public_path__ + "static/media/DoNotSneeze_07.05da63b4.png";